"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedError = void 0;
exports.errorToJson = errorToJson;
exports.errorToJsonString = errorToJsonString;
exports.catchToJsonString = catchToJsonString;
exports.catchToError = catchToError;
exports.catchToErrorJson = catchToErrorJson;
exports.rootCauseMessage = rootCauseMessage;
exports.isErrorLike = isErrorLike;
const MAX_SERIALIZED_ERROR_DEPTH = 8;
const MAX_SERIALIZED_NESTED_ERRORS = 40;
function errorToJson(error) {
    if (!error) {
        return null;
    }
    return serializeError(error, 0, { ancestors: new Set(), remaining: MAX_SERIALIZED_NESTED_ERRORS });
}
function serializeError(error, depth, state) {
    if ('toJSON' in error && typeof error.toJSON === 'function') {
        const serialized = error.toJSON();
        if (typeof serialized === 'object' && serialized !== null) {
            return serialized;
        }
    }
    const result = {
        message: error.message,
        stack: error.stack,
        name: error.name,
    };
    if (depth >= MAX_SERIALIZED_ERROR_DEPTH) {
        return result;
    }
    state.ancestors.add(error);
    const serializeInner = (inner) => {
        if (state.remaining <= 0 || state.ancestors.has(inner)) {
            return undefined;
        }
        state.remaining--;
        return serializeError(catchToError(inner), depth + 1, state);
    };
    const cause = 'cause' in error ? error.cause : undefined;
    if (cause !== undefined && cause !== null) {
        const serializedCause = serializeInner(cause);
        if (serializedCause) {
            result.cause = serializedCause;
        }
    }
    if (error instanceof AggregateError && Array.isArray(error.errors) && error.errors.length > 0) {
        const inner = error.errors;
        const serializedErrors = inner.map(serializeInner).filter((serialized) => serialized !== undefined);
        if (serializedErrors.length > 0) {
            result.errors = serializedErrors;
        }
        if (serializedErrors.length < inner.length) {
            result.errorsTotalCount = inner.length;
        }
    }
    state.ancestors.delete(error);
    return result;
}
function errorToJsonString(error) {
    if (!error) {
        return null;
    }
    return JSON.stringify(errorToJson(error));
}
function catchToJsonString(error) {
    if (error instanceof Error) {
        return errorToJsonString(error);
    }
    return JSON.stringify({
        message: String(error),
    });
}
function catchToError(error) {
    if (error instanceof Error) {
        return error;
    }
    if (isErrorLike(error)) {
        const err = new Error(error.message);
        if (error.name) {
            err.name = error.name;
        }
        if (error.stack) {
            err.stack = error.stack;
        }
        return err;
    }
    if (typeof error === 'object') {
        try {
            return new Error(JSON.stringify(error));
        }
        catch {
            return new Error(String(error));
        }
    }
    return new Error(String(error));
}
function catchToErrorJson(error) {
    return errorToJson(catchToError(error));
}
const MAX_CAUSE_DEPTH = 16;
function rootCauseMessage(error) {
    let deepest = catchToError(error).message;
    let current = error;
    const seen = new Set();
    for (let depth = 0; depth < MAX_CAUSE_DEPTH; depth++) {
        if (typeof current !== 'object' || current === null || seen.has(current)) {
            break;
        }
        seen.add(current);
        const cause = current.cause;
        if (cause === undefined || cause === null) {
            break;
        }
        const message = isErrorLike(cause) ? cause.message
            : typeof cause === 'string' ? cause
                : '';
        if (message.length > 0) {
            deepest = message;
        }
        current = cause;
    }
    return deepest;
}
function isErrorLike(error) {
    return (typeof error === 'object' &&
        error !== null &&
        typeof error.message === 'string' &&
        (typeof error.stack === 'string' || typeof error.stack === 'undefined') &&
        (typeof error.name === 'string' || typeof error.name === 'undefined'));
}
class NestedError extends Error {
    constructor(m, innerError) {
        super(m);
        this.innerError = innerError;
        Object.setPrototypeOf(this, NestedError.prototype);
    }
    toJSON() {
        return {
            message: this.message,
            stack: this.stack,
            name: this.name,
            innerError: errorToJson(this.innerError),
        };
    }
}
exports.NestedError = NestedError;
//# sourceMappingURL=Error.js.map